export const state = {
  serverError: null,
  retry: null,
};

export const getters = {};

export const mutations = {
  setServerError(state, value) {
    state.serverError = value;
  },
  setRetry(state, value) {
    state.retry = value;
  },
};

export const actions = {};
